import {Injectable} from '@angular/core';

import {HttpClient} from '@angular/common/http';

import {ApiVisa, BaseApiTemplateService, Core2Config, Pagination, PagingResponseModel} from "../../../shared";

import { Observable } from 'rxjs';
import { ConversationTagContainer } from '../../../../../../../models/mongodbSchema/aggregates';

@Injectable({ providedIn: 'root' })

export class ConversationTagService extends BaseApiTemplateService<ConversationTagContainer> {

  constructor(private http: HttpClient) {

    super();

    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'conversation-tag';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'conversation-tag';
    this.httpClient = http;
  }

  /*todo ADD api to get distinct tags*/
  getDistinctTags(apiVisa): Observable<PagingResponseModel<ConversationTagContainer>> {
    const url = `${this.apiUrl}/distinct`;
    return this.httpClient.get<PagingResponseModel<ConversationTagContainer>>(url, this.getHttpHeader(apiVisa));
  }
}